import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { Nav } from '@mirohq-internal/website-ui-foundation';
import { FlyoutMenu } from './flyout-menu.esm.js';

const MainMenu = ({ menu, menuItemsHoverBackground = true })=>{
    const [selected, setSelected] = useState('');
    const [animated, setAnimated] = useState(false);
    const handleClose = ()=>{
        setSelected('');
    };
    useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') {
                handleClose();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        selected
    ]);
    return jsx(Nav, {
        role: "navigation",
        className: "d-none d-xl-flex gap-200",
        "data-testid": "headerMenuWrapper",
        onMouseEnter: ()=>{
            /**
             * Prevent animations from running multiple times.
             */ setTimeout(()=>setAnimated(true), 600);
        },
        onMouseLeave: ()=>{
            /**
             * Set animated to false in order to allow the animations to run again
             * the next time the user hovers over the menu.
             */ setTimeout(()=>setAnimated(false), 300);
        },
        children: menu?.children?.flatMap((node)=>{
            return jsx(FlyoutMenu, {
                animated: animated,
                handleClose: handleClose,
                setSelected: setSelected,
                show: selected === node.label,
                withHoverBg: menuItemsHoverBackground,
                ...node
            }, node.label);
        })
    });
};

export { MainMenu };
